/** Map free-form flash variants to IconAlert-supported ones. */
export function indexerAlertVariant(
  variant: string,
): 'success' | 'info' | 'warning' | 'danger' {
  if (
    variant === 'success' ||
    variant === 'warning' ||
    variant === 'danger'
  ) {
    return variant;
  }
  return 'info';
}
